<template>
  <div>
    <div class='img-content  uk-position-relative border'>
      <img :src='carrierImg' alt='' draggable='false' v-if='carrierImg' />
      <div v-else>
        <el-empty :description="$t('integration.no_pictures_of_monitoring_points')" style='height:400px'></el-empty>
      </div>
      <span class='uk-position-absolute select-no cursor-pointer uk-text-nowrap' style='color: #344962' :style="{
                left: item.xpos * rate + 'px',
                top: item.ypos * rate + 'px'
            }" v-if='carrierImg' v-for='(item, index) in equiPoint' :key='index'>
                <template v-if='item.xpos && item.ypos'>

                    <!-- 传感器 -->
                    <el-tooltip v-if="item.deviceCatalog === '0'" class='item' effect='dark' placement='right'>
                        <div slot='content'>
                            {{ $t('public.is_abnormal') }}:{{ item.ex.join(',') || $t('public.normal') }}

                            <template v-if='item.ranges !== undefined && item.ranges.length'>
                                <span v-for='range in item.ranges'>
                                    <br />
                                    {{ range.code === 'temp' ? $t('device.temp_range') : $t('device.hum_range') }}:
                                    {{ range.name }} {{ range.min }}{{ range.unit_name }}~{{
                                    range.max }}{{ range.unit_name }}
                                </span>
                            </template>

                          <!-- <span v-if="item.min_hum !== undefined">
                              <br />
                              {{ $t('device.hum_range') }}:
                              {{ item.humidityRange.name }} {{ item.humidityRange.min }}{{ item.humidityRange.unit_name
                              }}~{{ item.humidityRange.max }}{{ item.humidityRange.unit_name }}
                          </span> -->
                            <br />
                            <span v-if='item.probeValue && item.probeValue.temp' class='uk-margin-small-right'>
                                {{ $t('device.temp_val') }}:
                                <span v-range="[item.probeValue['temp'].val, item.tempRange]">
                                    {{ item.probeValue.temp.val }}{{ defaultUnit['temp'] }}
                                </span>
                            </span>

                            <span v-if='item.probeValue && item.probeValue.hum'>{{ $t('device.hum_val') }}:<span
                              v-range="[item.probeValue['hum'].val, item.humidityRange]">{{ item.probeValue.hum.val
                              }}{{ defaultUnit['hum'] }}</span></span>
                        </div>
                        <span class='uk-text-bold'>{{ item.deviceCode }}
                            <template v-if='item.probeValue && item.probeValue.temp'><span
                              v-range="[item.probeValue['temp'].val, item.tempRange]" class='uk-text-bold'>{{
                                item.probeValue.temp.val }}{{ defaultUnit['temp'] }}</span></template>

                            <template v-if='item.probeValue && item.probeValue.hum'><span>/</span>
                                <span class='uk-text-bold' v-range="[item.probeValue['hum'].val, item.humidityRange]">{{
                                    item.probeValue.hum.val }}{{ defaultUnit['hum'] }}</span>
                            </template>
                        </span>
                    </el-tooltip>

                  <!-- 其他 -->
                    <el-tooltip v-else class='item' effect='dark' placement='right'>
                        <div slot='content'>{{ $t('public.is_abnormal') }}:{{ item.status ? $t('public.ex_conn') :
                          $t('public.normal') }}</div>
                        <span class='uk-text-bold'>{{ item.name }}</span>
                    </el-tooltip>
                </template>
            </span>

      <!-- 传入监测点图片和设备列表 -->
      <EditCarrier v-if='showEditImg' :show.sync='showEditImg' :carrierImg.sync='carrierImg' :detail='detailObj'
                   :equiPoint.sync='equiPoint'></EditCarrier>
    </div>
  </div>
</template>
<script>
import EditCarrier from './EditCarrier.vue'
import { sensorEx } from '@/utils/exception'
import { defaultUnit } from '@/utils/convert'

export default {
  computed: {
    defaultUnit () {
      return defaultUnit
    }
  },
  props: ['isShowEdit', 'detailObj'],
  data () {
    return {
      showEditImg: false,
      // 图片的缩放比
      rate: 0,
      carrierImg: '',
      // 根据挂载生成锚点列表
      equiPoint: []
    }
  },
  watch: {
    detailObj (newval) {
      // 详细信息改变意味着图片可能会发生改变
      this.carrierImg = (newval.carrierExtend && newval.carrierExtend.pictureBase64) || (newval.carrierType && newval.carrierType.pictureBase64)
      this.handleImg(this.carrierImg)
      // 标记异常
      this.equiPoint = sensorEx(this.detailObj.carrierDevice.deviceList)
      console.log(this.equiPoint)
      // 标记设备类型
    },
    carrierImg () {
      this.handleImg(this.carrierImg)
    }
  },
  components: {
    EditCarrier
  },
  methods: {
    detailImgSetting () {
      this.showEditImg = true
    },
    // 用于处理图片缩放比的计算 与锚点
    handleImg (picture) {
      // 获取图片的宽度  进而得到图片被压缩成400px后的缩放比  以后每次锚点计算 都要乘上这个缩放比
      const img = new Image()

      img.src = picture

      // 避免图片没回来时硬刷新坐标错位问题
      img.onload = () => {
        // 获取图片的缩放比 每次计算锚点都需要乘上这个比例
        if (img.width > img.height) {
          this.rate = 400 / img.width
        } else {
          this.rate = 400 / img.height
        }
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang='scss'>
.img-content {
  width: 400px;
  height: 400px;
  overflow: hidden;

  img {
    width: 100%;
    max-height: 400px;
    object-fit: contain;
    object-position: left top;
  }
}
</style>
